const overrideTabs = (theme) => {
  theme.overrides.MuiTabs = {
    flexContainer: {
      justifyContent: 'center'
    },
    indicator: {
      height: 4
    }
  };
  theme.overrides.MuiTab = {
    root: {
      fontSize: 24,
      fontStretch: 'normal',
      lineHeight: 1.25,
      color: theme.colors.text_primary,
      textTransform: 'none',
      '&:hover': {
        backgroundColor: theme.colorPalette.orange_10_op_08
      }
    },
    wrapper: {
      '@media (min-width: 0px)': {
        padding: theme.spacing(0, 5)
      }
    },
    selected: {
      fontWeight: 500
    }
  };
};

export default overrideTabs;
